import { Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ControlledSubstanceLogV2, ControlledSubstanceLogV2History } from '../../models/controlled-substance-logs.models';
import { ControlledSubstanceLogsService } from '../../services/controlled-substance-logs.service';

@Component({
  selector: 'app-controlled-substance-log-history-dialog',
  templateUrl: './controlled-substance-log-history.dialog.html',
  styleUrls: ['./controlled-substance-log-history.dialog.scss']
})
export class ControlledSubstanceLogHistoryDialogComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  
  historyEntries = new MatTableDataSource<ControlledSubstanceLogV2History>([]);
  displayedColumns = [
    'historyTimestamp',
    'operationType',
    'deaSchedule',
    'location',
    'date',
    'requestedForUser',
    'submittedUser',
    'amountAdministered',
    'wastage',
    'note'
  ];
  isLoading = true;

  constructor(
    public dialogRef: MatDialogRef<ControlledSubstanceLogHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { log: ControlledSubstanceLogV2 },
    private controlledSubstanceLogsService: ControlledSubstanceLogsService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loadHistoryData();
  }

  ngAfterViewInit(): void {
    this.historyEntries.sort = this.sort;
  }

  loadHistoryData(): void {
    if (!this.data.log || !this.data.log.id) {
      this.snackBar.open('Invalid log data', 'Close', { duration: 3000 });
      this.isLoading = false;
      return;
    }

    this.controlledSubstanceLogsService.getLogHistory(this.data.log.id).subscribe(
      (history: ControlledSubstanceLogV2History[]) => {
        this.historyEntries.data = history;
        this.isLoading = false;
      },
      error => {
        console.error('Error fetching log history:', error);
        this.snackBar.open('Error loading log history', 'Close', { duration: 3000 });
        this.isLoading = false;
      }
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }

}